import { AuthGuard } from './core/guards/auth.guard';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { MsalGuard } from '@azure/msal-angular';
import { CloseDevToolsComponent } from './features/close-dev-tools/close-dev-tools.component';
import { environment } from '../environments/environment';

const routes: Routes = [
  {
    path: environment.version,
    component: LayoutComponent,
    canActivate: [ AuthGuard ],
    children: [
      {
        path: 'TransportOperation',
        canActivate: [ AuthGuard ],
        loadChildren: () =>
          import('src/app/features/transport-operation/transport-operation.module')
            .then(m => m.TransportOperationModule)
      }, {
        path: 'PortalReport',
        canActivate: [ AuthGuard ],
        loadChildren: () =>
          import('src/app/features/report/report.module')
            .then(m => m.ReportModule)
      },
      {
        path: 'NotificationSubscribtion',
        canActivate: [ AuthGuard ],
        loadChildren: () =>
          import('src/app/features/notification-subscribtion/notification-subscribtion.module')
            .then(m => m.NotificationSubscribtionModule)
      },
      {
        path: 'User',
        canActivate: [ AuthGuard ],
        loadChildren: () =>
          import('src/app/features/user/user.module')
            .then(m => m.UserModule)
      },
      {
        path: 'Setting',
        canActivate: [ AuthGuard ],
        loadChildren: () =>
          import('src/app/features/setting/setting-routing.module')
            .then(m => m.SettingRoutingModule)
      },
      {
        path: 'Stock',
        canActivate: [ AuthGuard ],
        loadChildren: () =>
          import('src/app/features/stock/stock-routing.module')
            .then(m => m.StockRoutingModule)
      },
      {
        path: 'BillConfig',
        canActivate: [ AuthGuard ],
        loadChildren: () =>
          import('src/app/features/bill/bill-routing.module')
            .then(m => m.BillRoutingModule)
      },
      {
        path: 'Error',
        canActivate: [ AuthGuard ],
        loadChildren: () =>
          import('src/app/features/error/error.module')
            .then(m => m.ErrorModule)
      },
      {
        path: 'Faq',
        canActivate: [ AuthGuard ],
        loadChildren: () =>
          import('src/app/features/faq/faq.module')
            .then(m => m.FaqModule)
      },
      {
        path: 'TransportService',
        canActivate: [ AuthGuard ],
        loadChildren: () =>
          import('src/app/features/transport-service/transport-service.module')
            .then(m => m.TransportServiceModule)
      },
      {
        path: 'SystemSetting',
        canActivate: [ AuthGuard ],
        loadChildren: () =>
          import('src/app/features/system-setting/system-setting-routing.module')
            .then(m => m.SystemSettingRoutingModule)
      },
      {
        path: 'Notification',
        canActivate: [ AuthGuard ],
        loadChildren: () =>
          import('src/app/features/notifications/notifications-routing.module')
            .then(m => m.NotificationsRoutingModule)
      },
    ]
  },
  {
    path: `AzureAd`,
    canActivate: [ MsalGuard ],
    loadChildren: () => import('src/app/features/integration-auth/azure-ad/azure-ad.module').then(m => m.AzureAdModule)
  },
  {
    path: `login`,
    loadChildren: () => import('./features/login/login.module').then(m => m.LoginModule)
  },
  {
    path: `PasswordModification`,
    loadChildren: () => import('src/app/features/integration-auth/password-modification/password-modification.module').then(m => m.PasswordModificationModule)
  },
  {
    path: `closeDevTools`,
    component: CloseDevToolsComponent,
  }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule { }
